import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { useLanguage } from '../../context/LanguageContext';
import ArticleContent from '../../components/ArticleBlocks/ArticleBlocks';
import { dirFor, getTranslation } from '../../utils/article';



const EventTabs = ({ eventDetails }) => {
    const { t } = useTranslation('events');
    const { lang } = useLanguage();
    const [activeTab, setActiveTab] = useState('1');

    const picked = getTranslation(eventDetails, lang);
    if (!picked) return null;
    const { lang: shownLang, tr } = picked;
    const dir = dirFor(shownLang);

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    return (
        <div className="wpo-event-details-wrap">
            <div className="wpo-event-details-tab">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '1' })}
                            onClick={() => { toggle('1'); }}
                        >
                            {t('single.scheduleTab')}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '2' })}
                            onClick={() => { toggle('2'); }}
                        >

                            {t('single.mapTab')}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '3' })}
                            onClick={() => { toggle('3'); }}
                        >
                            {t('single.contactTab')}
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>

            <div className="wpo-event-details-content">
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <Row>
                            <Col sm="12">
                                <div id="Schedule" className="tab-pane active">
                                    <ArticleContent blocks={tr.content} lang={shownLang} dir={dir} />
                                    {/**<p>{t('single.scheduleNote')}</p>**/}
                                </div>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="2">
                        <Row>
                            <Col sm="12">
                                <div id="Map" className="tab-pane">
                                    <div className="contact-map">
                                        <iframe title='map' src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4040.426002222138!2d-6.881055824286272!3d33.98861307318101!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzPCsDU5JzE5LjAiTiA2wrA1Mic0Mi41Ilc!5e1!3m2!1sen!2sma!4v1766772292528!5m2!1sen!2sma"></iframe>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="3">
                        <Row>
                            <Col sm="12">
                                <div className="event-contact-links">
                                    {/* Call Phone */}
                                    <a href="tel:+212658152486" className="event-contact-link" >
                                        <i className="ti-mobile"></i>
                                        {t('single.callUs', { defaultValue: 'Call' })}
                                    </a>
                                    {/* WhatsApp */}
                                    <a href="https://wa.me/212658152486" className="event-contact-link" target="_blank" rel="noopener noreferrer" >
                                        <i className="fa fa-whatsapp" ></i>
                                        WhatsApp
                                    </a>
                                    {/* Facebook */}
                                    <a href="https://www.facebook.com/darMhamedAttaoui" className="event-contact-link" target="_blank" rel="noopener noreferrer" >
                                        <i className="ti-facebook" ></i>
                                        Facebook
                                    </a>
                                    {/* Email */}
                                    <a href="mailto:contact@dar-attaoui.ma" className="event-contact-link" >
                                        <i className="ti-email" ></i>
                                        Email
                                    </a>
                                </div>

                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </div>
        </div>
    );
}

export default EventTabs;


/**
    <div className="event-contact">
        <div className="wpo-donations-details">
            <form method="post" className="contact-validation-active" id="contact-form-main" onSubmit={SubmitHandler}>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 form-group">
                        <input type="text" className="form-control" name="name" id="name" placeholder={t('single.namePlaceholder')} />
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 form-group clearfix">
                        <input type="email" className="form-control" name="email" id="email" placeholder={t('single.emailPlaceholder')} />
                    </div>
                    <div className="col-lg-12 col-12 form-group">
                        <textarea className="form-control" name="note" id="note" placeholder={t('single.messagePlaceholder')}></textarea>
                    </div>
                    <div className="submit-area col-lg-12 col-12">
                        <button type="submit" className="theme-btn submit-btn">{t('single.submit')}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
 */